/* Thrive Ion 8 — product page interactions (variant picker, gallery, qty, carousel, sticky). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, fmt) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toLocaleString('en-US') : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (fmt || '${{amount}}').replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, s).replace('$', '$');
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.pdp-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCounters(scope) {
    (scope || document).querySelectorAll('[data-count]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '1');
      var target = parseFloat(el.getAttribute('data-count')); var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      if (isNaN(target)) return;
      var fmt = function (v) { var s = v.toFixed(dec); return dec === 0 ? Number(s).toLocaleString() : s; };
      if (reduce) { el.textContent = fmt(target); return; }
      var run = function () {
        var t0 = performance.now(), dur = 1500;
        var step = function (t) { var p = Math.min(1, (t - t0) / dur); el.textContent = fmt(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target); };
        requestAnimationFrame(step);
      };
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (e) { e.forEach(function (en) { if (en.isIntersecting) { run(); io.disconnect(); } }); }, { threshold: 0.5 }); io.observe(el); } else run();
    });
  }

  /* ---- variant picker ---- */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-pdp-product]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      var dataEl = root.querySelector('[data-pdp-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var moneyFmt = root.getAttribute('data-money-format') || '${{amount}}';
      var selected = {};
      root.querySelectorAll('[data-pdp-option]').forEach(function (group) {
        var name = group.getAttribute('data-pdp-option');
        var checked = group.querySelector('[aria-checked="true"]');
        selected[name] = checked ? checked.getAttribute('data-value') : (group.querySelector('[data-value]') && group.querySelector('[data-value]').getAttribute('data-value'));
      });

      function currentVariant() {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) {
            var groups = root.querySelectorAll('[data-pdp-option]');
            var name = groups[i] ? groups[i].getAttribute('data-pdp-option') : null;
            return name ? selected[name] === opt : true;
          });
        });
      }

      function setText(sel, txt) { var n = root.querySelector(sel); if (n) n.textContent = txt; }

      var stageImg = root.querySelector('[data-pdp-stage-img]');

      // order thumbnails: "main" first, then by trailing number in the filename
      function thumbKey(t) {
        var f = (t.getAttribute('data-full') || '').split('/').pop().split('?')[0];
        if (/main/i.test(f)) return 0;
        var m = f.match(/(\d+)\.[a-z0-9]+$/i);
        return m ? parseInt(m[1], 10) : 9999;
      }
      var thumbsWrap = root.querySelector('.pdp-thumbs');
      if (thumbsWrap) {
        [].slice.call(thumbsWrap.querySelectorAll('[data-pdp-thumb]'))
          .sort(function (a, b) { return thumbKey(a) - thumbKey(b); })
          .forEach(function (t) { thumbsWrap.appendChild(t); });
      }

      function update() {
        var v = currentVariant() || variants[0];
        var idInput = root.querySelector('[name="id"]'); if (idInput) idInput.value = v.id;
        setText('[data-pdp-price]', money(v.price, moneyFmt));
        var compEl = root.querySelector('[data-pdp-compare]');
        var saveEl = root.querySelector('[data-pdp-save]');
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (compEl) { compEl.textContent = money(v.compare_at_price, moneyFmt); compEl.style.display = ''; }
          if (saveEl) { saveEl.textContent = 'Save ' + money(v.compare_at_price - v.price, moneyFmt); saveEl.style.display = ''; }
        } else { if (compEl) compEl.style.display = 'none'; if (saveEl) saveEl.style.display = 'none'; }
        var fin = root.querySelector('[data-pdp-finance]');
        if (fin) fin.textContent = 'or ' + money(Math.round(v.price / 24), moneyFmt) + '/mo for 24 months · 0% APR';
        // sticky mirror
        document.querySelectorAll('[data-pdp-sticky-price]').forEach(function (n) { n.textContent = money(v.price, moneyFmt); });
        document.querySelectorAll('[data-pdp-sticky-name]').forEach(function (n) { n.textContent = selected['Model'] || n.textContent; });
        document.querySelectorAll('[data-pdp-sticky-finish]').forEach(function (n) { n.textContent = (selected['Finish'] || '') + ' · 7 modes'; });
        // add to cart availability
        root.querySelectorAll('[data-pdp-buy],[data-pdp-atc]').forEach(function (btn) {
          if (v.available === false) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Sold out'; }
          else { btn.removeAttribute('disabled'); }
        });
        // selected labels
        setText('[data-pdp-model-name]', selected['Model'] || '');
        setText('[data-pdp-finish-name]', selected['Finish'] || '');
        // show only the selected model's images, then swap main image + active thumb
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
          var owner = t.getAttribute('data-owner');
          t.style.display = (owner === selected['Model']) ? '' : 'none';
        });
        if (v.image) {
          if (stageImg) stageImg.src = v.image;
          root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t.getAttribute('data-full') === v.image ? 'true' : 'false');
          });
        }
      }

      root.querySelectorAll('[data-pdp-option] [data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-pdp-option]');
          var name = group.getAttribute('data-pdp-option');
          selected[name] = btn.getAttribute('data-value');
          group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
          update();
        });
      });
      update();

      // quantity
      var qty = root.querySelector('[data-pdp-qty]');
      if (qty) {
        var dec = root.querySelector('[data-pdp-qty-dec]'), inc = root.querySelector('[data-pdp-qty-inc]');
        if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
        if (inc) inc.addEventListener('click', function () { qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1); });
      }

      // gallery
      root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          root.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          var full = t.getAttribute('data-full'); var lab = t.getAttribute('data-label');
          if (stageImg && full) { stageImg.src = full; stageImg.alt = lab || ''; }
          var labEl = root.querySelector('[data-pdp-stage-label]'); if (labEl && lab) labEl.textContent = lab;
        });
      });
    });
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-pdp-carousel]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '1');
      var track = root.querySelector('[data-pdp-track]'); if (!track) return;
      var step = function () { var c = track.querySelector('*'); return c ? c.getBoundingClientRect().width + 22 : 380; };
      var p = root.querySelector('[data-pdp-prev]'), n = root.querySelector('[data-pdp-next]');
      if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  function initSticky(scope) {
    (scope || document).querySelectorAll('[data-pdp-sticky]:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '1');
      var anchor = document.querySelector('.pdp-hero');
      function onScroll() { bar.classList.toggle('is-show', anchor ? anchor.getBoundingClientRect().bottom < 0 : window.scrollY > 700); }
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    });
  }

  function initAll(scope) { initReveal(scope); initCounters(scope); initProduct(scope); initCarousels(scope); initSticky(scope); }
  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
